/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type UserSolutionApplicationListResponseApplicationsItemStatus = typeof UserSolutionApplicationListResponseApplicationsItemStatus[keyof typeof UserSolutionApplicationListResponseApplicationsItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserSolutionApplicationListResponseApplicationsItemStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  INACTIVE: 'INACTIVE',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
} as const;
